import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/Button';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function HeroSection() {
  const painPoints = ['Si para llenar la agenda tienes que publicar descuentos constantemente', 'Si tus clientes comparan tu precio con el spa más barato de la ciudad', 'Si Groupon o los cupones te traen clientes que no regresan sin otra oferta', 'Si tienes tratamientos de alto valor (Botox, microblading, laser) pero no sabes cómo atraer a quienes los pueden pagar', 'Si tu Instagram tiene seguidores pero no se convierten en citas'];
  return <section className="relative min-h-screen flex items-center justify-center py-20 md:py-28 px-4 overflow-hidden" data-id="element-7">
      {/* Subtle background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[120px] pointer-events-none" data-id="element-8" />

      <motion.div className="max-w-4xl mx-auto w-full relative z-10" variants={containerVariants} initial="hidden" animate="visible" data-id="element-9">
        <motion.div variants={itemVariants} className="text-center mb-12" data-id="element-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-gold mb-6 leading-tight tracking-tight" data-id="element-11">
            ¿Regalando servicios de $200 por $80 solo para tener la agenda
            ocupada?
          </h1>
          <p className="text-lg md:text-xl text-neutral-300 leading-relaxed max-w-3xl mx-auto" data-id="element-12">
            Llenamos tu spa con clientes que buscan lujo, bienestar y
            resultados. Clientes que pagan el precio completo, regresan cada mes
            y te refieren a sus amigas.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="bg-surface border border-border rounded-2xl p-6 md:p-10 mb-12 shadow-2xl" data-id="element-13">
          <ul className="space-y-6" data-id="element-14">
            {painPoints.map((point, index) => <motion.li key={index} variants={itemVariants} className="flex items-start gap-4" data-id="element-15">
                <AlertCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" aria-hidden="true" data-id="element-16" />
                <span className="text-neutral-300 text-base md:text-lg leading-relaxed" data-id="element-17">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </motion.div>

        <motion.div variants={itemVariants} className="flex justify-center" data-id="element-18">
          <Button href="https://calendar.app.google/PYPdcRoYne7QrNJA7" className="w-full md:w-auto text-sm md:text-base" data-id="element-19">
            QUIERO CLIENTES DE ALTO TICKET
          </Button>
        </motion.div>
      </motion.div>
    </section>;
}